module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (4).ef274c5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (4).jpg
// module id = 343
// module chunks = 0